// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryArt_root__++4p5"};